const hospitalHome = [
  {
    path: '/hospital_home',
    name: '医院首页',
    component: () => import('@/pages/hospitalHome')
  },
  {
    path: '/hospital_intro',
    name: '医院介绍',
    component: () => import('@/pages/hospitalHome/intro')
  }
]

export default hospitalHome
